import './Loading.scss'
import React from "react";

const Loading = () => (
    <div className='loader'/>
)

export default  Loading;
